import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import KibabMenu from "../../../../../assets/icons/kibab-menu";
import { useDispatch } from "react-redux";
import {
  addTaxCombinationAction,
  deleteTaxCombinationItemAction,
  taxTypeDropDownAction,
  updateTaxCombinationAction,
} from "../../../../../redux/actions/settings-action";
import InputField from "../../../../forms/input-field";
import Select from "react-select";
import * as Yup from "yup";
import successToast from "../../../../helper-components/success-toast";
import errorToast from "../../../../helper-components/error-toast";
import DeleteIcon from "../../../../../assets/icons/delete-icon";
import AddButton, { DraftButton } from "../../../../buttons/button";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "none",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
};

const TaxCombination = ({ isView, editingData, reloadData, toogleChange }) => {
  const tableHeading = [
    "Tax Type",
    "%",
    "Sales Tax Account",
    "Purchase Tax Account",
    "",
  ];
  const [selectedDOtIndex, setSelectedDOtIndex] = useState(null);
  const [taxTypes, setTaxTypes] = useState([]);
  const [usedTaxTypes, setUsedTaxTypes] = useState([]);

  const dispatch = useDispatch();

  const handleFieldChange = (path, field, value, setFieldValue) => {
    setFieldValue(`${path}.${field}`, value);
  };

  // For existing rows: always store BOTH id and name
  const handleFieldChange_Select = (path, field, option, setFieldValue) => {
    setFieldValue(`${path}.tax_type_id`, option?.value ?? null);
    setFieldValue(`${path}.tax_type_name`, option?.label ?? "");
  };

  const element = document.querySelector(".innerLayoutScroller");
  if (element && element.style.overflow === "auto") {
    element.style.overflow = "hidden";
  }

  // NEW: handle new-row logic:
  //  - When tax_type_name is selected, push row to tax_combination_items
  //  - Reset newLine
  const handleNewLineFieldChange = (field, value, setFieldValue, values) => {
    if (!field) return;

    // Special behavior for tax type select in new row
    if (field === "tax_type_name") {
      if (value) {
        // Build new item using current newLine values + selected option
        const newItem = {
          tax_type_id: value.value,
          tax_type_name: value.label,
          percentage: values.newLine.percentage || "",
          sales_tax_acc: values.newLine.sales_tax_acc || "",
          purchase_tax_acc: values.newLine.purchase_tax_acc || "",
        };

        const updatedItems = [...values.tax_combination_items, newItem];

        setFieldValue("tax_combination_items", updatedItems);

        // Reset newLine row to blank
        setFieldValue("newLine", {
          tax_type_name: "",
          percentage: "",
          sales_tax_acc: "",
          purchase_tax_acc: "",
        });
      } else {
        // If user clears selection (if made clearable later)
        setFieldValue("newLine.tax_type_name", "");
      }
    } else {
      // Normal behavior for other fields in newLine
      setFieldValue(`newLine.${field}`, value);
    }
  };

  const validationSchema = Yup.object().shape({
    code: Yup.string().required("Required"),
  });

  const initialValues = {
    id: editingData?.id || "",
    code: editingData?.code || "",
    rate: editingData?.rate || "",
    effective_from: editingData?.effective_from || "",
    combination: editingData
      ? editingData?.tax_combination_items
          ?.map((taxComb) => taxComb?.tax_type?.name || taxComb?.tax_type_name)
          .join(" + ")
      : "",
    // Assume backend already sends tax_type_id; if not, you can map from tax_type object here
    tax_combination_items: editingData?.tax_combination_items || [],
    newLine: {
      tax_type_name: "",
      percentage: "",
      sales_tax_acc: "",
      purchase_tax_acc: "",
    },
  };

  useEffect(() => {
    console.log("Editing data", editingData);
    dispatch(taxTypeDropDownAction({}, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    if (!isView) {
      const filteredData = data?.data;
      console.log("data", data?.data);
      console.log("editing data", editingData);
      console.log(
        "Tax types",
        filteredData?.map((item) => ({ label: item?.name, value: item?.id })) ??
          []
      );
      setTaxTypes(
        filteredData?.map((item) => ({
          label: item?.name,
          value: item?.id,
        })) ?? []
      );
    } else {
      setTaxTypes(
        data?.data?.map((item) => ({
          label: item?.name,
          value: item?.id,
        })) ?? []
      );
    }

    setUsedTaxTypes(
      data?.data?.map((item) => ({
        label: item?.name,
        value: item?.id,
      })) ?? []
    );
  };

  const onError = (data) => {};

  // FIXED onSubmit:
  //  - Do NOT try to append newLine here anymore (it’s already pushed on select)
  //  - Map tax_type_id from item.tax_type_id (ID!), not tax_type_name
  const onSubmit = (values, { setSubmitting }) => {
    // Only keep rows that actually have a tax type id
    const combinationItems = (values.tax_combination_items || [])
      .filter((item) => item.tax_type_id)
      .map((item) => ({
        percentage: Number(item.percentage) || 0,
        purchase_tax_acc: item.purchase_tax_acc || "",
        sales_tax_acc: item.sales_tax_acc || "",
        tax_type_id: item.tax_type_id || "", // ✅ now using ID, not name
      }));

    const dispatchingValues = {
      taxComination: {
        code: values.code,
        rate: combinationItems.reduce(
          (sum, item) => sum + (Number(item.percentage) || 0),
          0
        ),
        effective_from: values.effective_from || "",
      },
      taxCominationItems: combinationItems,
    };

    if (combinationItems.length === 0) {
      errorToast("Add at least one combination");
      setSubmitting(false);
      return;
    }

    if (!dispatchingValues.taxComination.effective_from) {
      errorToast("Effective from date is required");
      setSubmitting(false);
      return;
    }

    if (values.id) {
      dispatch(
        updateTaxCombinationAction(
          { id: values.id, ...dispatchingValues },
          onUpdateSuccess,
          onUpdateError
        )
      );
      console.log("Tried to update submit", { id: values.id, ...dispatchingValues });
    } else {
      dispatch(
        addTaxCombinationAction(
          dispatchingValues,
          onCreateSuccess,
          onCreateError
        )
      );
      console.log("Tried to add submit", dispatchingValues);
    }

    setSubmitting(false);
  };

  const onCreateSuccess = (data) => {
    reloadData();
    toogleChange();
    successToast(data?.message);
  };
  const onCreateError = (data) => {
    errorToast(data?.message);
  };

  const onUpdateSuccess = (data) => {
    reloadData();
    toogleChange();
    successToast(data?.message);
  };
  const onUpdateError = (data) => {
    errorToast(data?.message);
  };

  const onClickDelete = (id) => {
    dispatch(deleteTaxCombinationItemAction({ id }, onDelSuccess, onDelError));
  };

  const onDelSuccess = (data) => {
    setSelectedDOtIndex(null);
    reloadData();
    toogleChange();
    successToast(data?.message);
  };
  const onDelError = (data) => {
    setSelectedDOtIndex(null);
    errorToast(data?.message);
  };

  const componentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setSelectedDOtIndex(null);
    }
  };

  return (
    <div className="pl-2">
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, dirty, handleSubmit }) => (
          <Form className="pt-4">
            <div
              onClick={handleClickOutside}
              className="flex flex-col justify-between"
              style={{ height: "70vh" }}
            >
              <div className="flex gap-4">
                <div style={{ maxWidth: "12rem" }} className="w-full">
                  <InputField
                    maxLength={10}
                    isDisabled={isView}
                    containerClass="mt-1"
                    isRequired={true}
                    type="text"
                    name="code"
                    placeholder="Code"
                    label="Code"
                    labelWidth="4rem"
                  />
                </div>
                <div style={{ maxWidth: "12rem" }} className="w-full">
                  <InputField
                    //isDisabled={true}
                    containerClass="mt-1"
                    isRequired={false}
                    type="text"
                    name="rate"
                    placeholder="Rate"
                    label="Rate"
                    labelWidth="4rem"
                  />
                </div>
                <div style={{ maxWidth: "28rem" }} className="w-full">
                  <InputField
                    //isDisabled={true}
                    containerClass="mt-1"
                    isRequired={false}
                    type="text"
                    name="combination"
                    placeholder="Combination"
                    label="Combination"
                    labelWidth="7rem"
                  />
                </div>
                <div style={{ maxWidth: "18rem" }} className="w-full">
                  <InputField
                    //isDisabled={isView}
                    containerClass="mt-1"
                    isRequired={false}
                    type="date"
                    name="effective_from"
                    placeholder="Eff"
                    label="Effective From"
                    labelWidth="7rem"
                  />
                </div>
              </div>
              <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
                <table className=" w-full ">
                  <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                    <tr className="relative h-[50px]">
                      {tableHeading.map((heading, index) => (
                        <th
                          className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                          key={heading}
                        >
                          {heading?.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ position: "relative" }}>
                    {values.tax_combination_items.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{ width: "15rem", minWidth: "11rem" }}
                          className={`tab-cell text-sm fw_400 text-secondary`}
                        >
                          <Select
                            isDisabled={isView}
                            options={taxTypes}
                            name={`tax_combination_items[${index}].tax_type_id`}
                            placeholder="Select a Tax Type"
                            value={
                              taxTypes.find(
                                (opt) =>
                                  opt.value ===
                                  values.tax_combination_items[index]
                                    ?.tax_type_id
                              ) || null
                            }
                            onChange={(option) =>
                              handleFieldChange_Select(
                                `tax_combination_items[${index}]`,
                                "tax_type_id",
                                option,
                                setFieldValue
                              )
                            }
                            styles={customStyles}
                          />
                        </td>
                        <td className={`tab-cell text-sm fw_400 text-secondary`}>
                          <Field
                            name={`tax_combination_items[${index}].percentage`}
                            placeholder="percentage"
                            disabled={isView}
                            onChange={(e) =>
                              handleFieldChange(
                                `tax_combination_items[${index}]`,
                                "percentage",
                                e.target.value,
                                setFieldValue
                              )
                            }
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 px-1 py-2"
                          />
                        </td>
                        <td className={`tab-cell text-sm fw_400 text-secondary`}>
                          <Field
                            name={`tax_combination_items[${index}].sales_tax_acc`}
                            placeholder="sales_tax_acc"
                            disabled={isView}
                            onChange={(e) =>
                              handleFieldChange(
                                `tax_combination_items[${index}]`,
                                "sales_tax_acc",
                                e.target.value,
                                setFieldValue
                              )
                            }
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 px-1 py-2"
                          />
                        </td>
                        <td className={`tab-cell text-sm fw_400 text-secondary`}>
                          <Field
                            name={`tax_combination_items[${index}].purchase_tax_acc`}
                            placeholder="purchase_tax_acc"
                            disabled={isView}
                            onChange={(e) =>
                              handleFieldChange(
                                `tax_combination_items[${index}]`,
                                "purchase_tax_acc",
                                e.target.value,
                                setFieldValue
                              )
                            }
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 px-1 py-2"
                          />
                        </td>

                        <td className="tab-cell text-sm fw_400 text-secondary p-8">
                          <button
                            type="button"
                            onClick={() => setSelectedDOtIndex(index)}
                          >
                            <KibabMenu />
                          </button>
                          {selectedDOtIndex === index && (
                            <div
                              ref={componentRef}
                              style={{
                                position: "absolute",
                                right: "4rem",
                                boxShadow:
                                  "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                              }}
                              className="bg-white rounded w-38"
                            >
                              <div className="w-full p-3">
                                <button
                                  className="w-full flex align-middle gap-2 px-2 py-1"
                                  type="button"
                                  onClick={() => onClickDelete(item?.id)}
                                >
                                  <div className="mt-1">
                                    <DeleteIcon />
                                  </div>
                                  <span className="text-sm">Delete</span>
                                </button>
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}

                    {/* NEW ROW: only show if not view AND
                        (no rows OR last row has a tax_type_id) */}
                    {!isView &&
                      (values.tax_combination_items.length === 0 ||
                        values.tax_combination_items[
                          values.tax_combination_items.length - 1
                        ]?.tax_type_id) && (
                        <tr>
                          <td
                            style={{ width: "15rem", minWidth: "11rem" }}
                            className={`tab-cell z-10  text-sm fw_400 text-secondary`}
                          >
                            <Select
                              options={taxTypes}
                              name="newLine.tax_type_name"
                              placeholder="Select Tax Type"
                              value={values.newLine.tax_type_name}
                              onChange={(option) =>
                                handleNewLineFieldChange(
                                  "tax_type_name",
                                  option,
                                  setFieldValue,
                                  values
                                )
                              }
                              styles={{
                                ...customStyles,
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              menuPortalTarget={document.body}
                              autoFocus
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.percentage"
                              placeholder="Percentage"
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*\.?\d*$/.test(value)) {
                                  handleNewLineFieldChange(
                                    "percentage",
                                    value,
                                    setFieldValue,
                                    values
                                  );
                                } else {
                                  errorToast(
                                    "Enter only numeric value for Rate(%)"
                                  );
                                }
                              }}
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.sales_tax_acc"
                              placeholder="Sales tax account"
                              onChange={(e) =>
                                handleNewLineFieldChange(
                                  "sales_tax_acc",
                                  e.target.value,
                                  setFieldValue,
                                  values
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.purchase_tax_acc"
                              placeholder="Purchase tax account"
                              onChange={(e) =>
                                handleNewLineFieldChange(
                                  "purchase_tax_acc",
                                  e.target.value,
                                  setFieldValue,
                                  values
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          ></td>
                        </tr>
                      )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="flex justify-between w-full bg-white mt-4 py-4 px-2 invoice-bottom-container">
              <DraftButton
                onclkFn={toogleChange}
                text={isView ? "Back" : "Cancel"}
              />
              <AddButton
                onclkFn={handleSubmit}
                prefixIcon={false}
                text="Save"
                type="submit"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TaxCombination;
